var MpBaseLegislation = {

    created: function() {},

    mounted: function() {
        this.setInitialPage(parseInt(this.$refs.ssrPaginator.dataset.page));
        this.$refs.ssrPaginator.querySelectorAll('.js-page-item').forEach(this.addDomPage);

        this.init();
    },

    updated: function() {
        if (!this.isInitialized) {
            this.init();
        }
    },

    destroy: function() {
        window.removeEventListener('hashchange', this.onHashChange);
    },

    mixins: [MpPaginator],

    data: function() {
        return {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',

            itemList: [],

            overlay: null,

            isInitialized: false,
        };
    },

    computed : {
        totalResults: function () {
            return this.totalResultsTPL.replace('%s', this.totalItems);
        },
    },

    methods: {

        getDateFromString: function(dateStr) {
            var dateParts = dateStr.split('-');
            return new Date(parseInt(dateParts[0]), parseInt(dateParts[1])-1, parseInt(dateParts[2]));
        },

        addDomItem: function(item) {
            this.itemList.push({
                id: item.getAttribute('data-id'),
                date: item.getAttribute('data-date'),
                state_name: item.getAttribute('data-state'),
                range_id: item.getAttribute('data-range-id'),
                range_name: item.getAttribute('data-range-name'),
                categories: item.getAttribute('data-category-label'),
                title: item.getAttribute('data-title'),
                intro: item.getAttribute('data-intro'),
                uri: item.getAttribute('data-uri'),
            });
        },

        onItemsLoaded: function(response) {
            if (response.data.result == this.RESPONSE_OK) {
                this.itemList = response.data.registers;
                this.totalItems = response.data.total;
                this.updatePaginator(response);
            }
        },

        init: function() {
            if (this.isInitialized) {
                return;
            }

            window.addEventListener('hashchange', this.onHashChange);
            this.onHashChange();

            this.initPaginator();
            this.isInitialized = true;
        },
    },

    filters: {},
};
